import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import {App} from './App';
import Login from './Login';
import 'bootstrap/dist/css/bootstrap.min.css';


import { Provider } from 'react-redux'
import store from './store'
import RegistroNuevoUsuario from './Register';
import MainRoutes from './MainRoutes';
import {
  BrowserRouter as Router
} from "react-router-dom"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Provider store={store}>
        {/*<Login />*/}
        <MainRoutes />
      </Provider>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
